export const ANNOUNCEMENT_EMAIL_PREVIEW_ASSETS = {
    headerImage:
        "https://res.cloudinary.com/dh1hsqbbp/image/upload/v1770025053/header_i7ptyc.png",
    footerLogo:
        "https://res.cloudinary.com/dh1hsqbbp/image/upload/v1770025053/footer-logo_qdpbzr.png",
    socialIcons: {
        twitter:
            "https://res.cloudinary.com/dh1hsqbbp/image/upload/v1770025055/twitter.png_qgqrh5.png",
        tiktok:
            "https://res.cloudinary.com/dh1hsqbbp/image/upload/v1770025054/tiktok_vqe1ep.png",
        instagram:
            "https://res.cloudinary.com/dh1hsqbbp/image/upload/v1770025054/insta_yl3tfm.png",
    },
} as const;
